import axiosClient from '../../../components/api/axiosClient';
import { buildDirectPaymentLinkUrl } from '../../../config/billetterie';

function withPublicUrl(link) {
    if (!link) return null;
    return {
        ...link,
        public_url: link.public_url || buildDirectPaymentLinkUrl(link.token),
    };
}

export async function fetchPaymentLinks() {
    const response = await axiosClient.get('/dashboard/payment-links');
    const links = (response.data?.data || []).map(withPublicUrl);
    const stats = response.data?.stats || getPaymentLinksStats(links);
    return { links, stats, noContent: Boolean(response.data?.noContent) };
}

export async function fetchPaymentLinkById(id) {
    const response = await axiosClient.get(`/dashboard/payment-links/${id}`);
    return withPublicUrl(response.data?.data || null);
}

export async function createPaymentLink(payload) {
    const body = {
        event_id: payload.event_id,
        pricing_mode: payload.pricing_mode || 'pass',
        ticket_id: payload.ticket_id || null,
        quantity: payload.quantity || 1,
        custom_amount: payload.custom_amount ?? payload.unit_price ?? null,
        custom_label: payload.custom_label || null,
        recipient_name: payload.recipient_name || null,
        recipient_phone: payload.recipient_phone || null,
        recipient_email: payload.recipient_email || null,
        note: payload.note || null,
        expires_at: payload.expires_at,
        max_uses: Number(payload.max_uses) || 1,
    };

    const response = await axiosClient.post('/dashboard/payment-links', body);
    return withPublicUrl(response.data?.data || null);
}

export async function cancelPaymentLink(id) {
    const response = await axiosClient.post(`/dashboard/payment-links/${id}/cancel`);
    return withPublicUrl(response.data?.data || null);
}

export async function updatePaymentLinkRecipient(id, payload) {
    const response = await axiosClient.put(`/dashboard/payment-links/${id}/recipient`, {
        recipient_name: payload.recipient_name ?? null,
        recipient_phone: payload.recipient_phone ?? null,
        recipient_email: payload.recipient_email ?? null,
        note: payload.note ?? null,
    });
    return withPublicUrl(response.data?.data || null);
}

export function getPaymentLinksStats(links = []) {
    const active = links.filter((l) => l.status === 'active').length;
    const paid = links.filter((l) => l.status === 'paid').length;
    const pending = links.filter((l) => l.status === 'active' || l.status === 'exhausted').length;
    const collected = links
        .filter((l) => l.status === 'paid')
        .reduce((sum, l) => sum + (Number(l.total_amount) || (Number(l.unit_price) || 0) * (Number(l.quantity) || 0)), 0);

    return { active, paid, pending, collected, total: links.length };
}

export const STATUS_META = {
    active: {
        label: 'Actif',
        className: 'c1lu4 c19il',
    },
    paid: {
        label: 'Payé',
        className: 'c1lu4 c19il',
    },
    expired: {
        label: 'Expiré',
        className: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
    },
    cancelled: {
        label: 'Annulé',
        className: 'cx6qj cz4gk',
    },
    exhausted: {
        label: 'Épuisé',
        className: 'cfts0 c5px7',
    },
};
